// extracted by mini-css-extract-plugin
export default {"termsModal":"termsModal_termsModal__5tWmg","termsContent":"termsModal_termsContent__TcU1m"};